<template>
  <div :class="['container', floor.$rowClass]">
    <scroll-bar>
      <div 
        class="item" 
        v-for="(item, index) of floor.list || []"
        :key="index" 
        :style="`background-image:url(${item.bgImageUrl})`"
      >
        <div class="header">
          <span :class="['hours', index == 0 ? 'first-hours' : '']">{{item.hours}}</span>
          <div class="timer" v-if="item.visibleCountDown">
            <van-count-down :time="item.seconds"
              @finish="onCountDownFinish"
            >
              <template #default="timeData">
                <span class="count">{{ addZero(timeData.hours) }}</span>
                <span class="split">:</span>
                <span class="count">{{ timeData.minutes }}</span>
                <span class="split">:</span>
                <span class="count">{{ timeData.seconds }}</span>
              </template>
            </van-count-down>
          </div>
          <div class="timer date" v-else-if="item.started">抢购中</div>
          <div class="timer date" v-else>{{item.month}}</div>
        </div>
        <div :class="[item.$row]">
          <scroll-bar ref="scrollBar" class="item-scroll-bar">
            <div 
              :class="['goods', goods.buttonStatus == 1 ? 'no-stock' : '', goods.buttonStatus == 4 ? 'reminded' : '']"
              v-for="(goods, idx) of item.goodsList"
              :key="goods.seckillId" 
              @click="$emit('jump', { item: goods, index })">
              <div class="img-box">
                <img 
                  class="goods-img" 
                  v-if="goods.indexImageUrl"
                  :src="goods.indexImageUrl + '?x-oss-process=style/style_index_flashsale'" />
                <img 
                  class="goods-img photo" 
                  v-if="goods.photoFrameUrl" 
                  :src="goods.photoFrameUrl + '?x-oss-process=style/style_index_flashsale'" />
                <template v-if="item.goodsList.length > 1">
                  <div class="status qiang" v-if="goods.qiangName">{{goods.qiangName}}</div>
                  <div 
                    class="status remind" 
                    v-if="goods.remindName"
                    @click.stop="onSeckillTixing(index, idx)">{{goods.remindName}}</div>
                </template>
              </div>
              <div class="desc">
                <div class="name">{{goods.goodsName}}</div>
                <div class="price"><span class="symbol">￥</span>{{goods.goodsPrice}}</div>
                <div class="btn-box">
                  <div class="button qiang" v-if="goods.qiangName">
                    <div class="icon">
                      <img class="icon-image" src="@/assets/home/style-two-qiang.png"/>
                    </div>
                    <span>{{goods.qiangName}}</span>
                  </div>
                  <div 
                    class="button remind" 
                    v-if="goods.remindName"
                    @click.stop="onSeckillTixing(index, idx)"
                  >
                    <div class="icon">
                      <img class="icon-image" src="@/assets/home/style-two-clock.png"/>
                    </div>
                    <span>{{goods.remindName}}</span>
                  </div>
                </div>
              </div>
            </div>
          </scroll-bar>
        </div>
      </div>
      <div 
        class="item store" 
        v-if="floor.list && floor.list.length == 1"
        :style="`background-image:url(${floor.style.branchBgImageUrl})`"
        @click="onNavigateTo"
      >
        <img class="image" :src="floor.style.branchAdImageUrl" />
      </div>
    </scroll-bar>
  </div>
</template>

<script>
import http from "@/utils/axios";
import { navigateTo } from '@/views/activities/utils'
import ScrollBar from '../../components/scroll-bar'
export default {
  components: { ScrollBar },
  props: {
    floor: Object,
    home: Object
  },
  created() {
    this.makeMap()
    this.init()
  },
  methods: {
    makeMap() {
      this.rows = {
        1: 'row-one',
        2: 'row-two',
        3: 'row-three'
      }
      this.goodsRows = {
        1: 'goods-one',
        2: 'goods-same goods-two',
        3: 'goods-same goods-three'
      }
      this.buttonNames = {
        1: '已抢完',
        2: '马上抢',
        3: '提醒我',
        4: '已设提醒'
      }
    },
     /**
     * 使用this.$set会触发watch
     * 所以用if(this.unwatch) this.unwatch() 和
     * this.unwatch = this.$watch('floor', this.init) 包裹代码
     * 保证每次执行只触发一次
     */
    init() {
      if(this.unwatch) this.unwatch();
      this.floor.$updating = true
      this.normalizeFloor()
      this.updateScrollBar()
      this.unwatch = this.$watch('floor', this.init)
    },
    normalizeFloor() {
      const { floor, home } = this
      Object.assign(floor, home.seckillComponent)
      this.$set(floor, 'style', floor.seckillComponentStyle2)
      this.$set(floor, 'list', floor.seckillActivityList || [])
      floor.list.forEach((item, i) => {
        this.$set(item, 'bgImageUrl', i === 0 ? floor.style.leftBgImageUrl : floor.style.rightBgImageUrl)
        this.normalizeGoods(item)
        this.normalizeDate(item)
      })
      this.normalizeLink(floor)
      this.makeRow(floor)
    },
    makeRow(floor) {
      const len = floor.list.length
      this.$set(floor, '$rowClass', this.rows[len >= 3 ? 3 : len])
    },
    /**
     * 重新映射一下跳转地址
     * 从而可以使用navigateTo
     */
    normalizeLink(floor) {
      const links = {
        NONE: 1,
        LINK: 2,
        BRANCH: 4,
      }
      const { style } = floor
      style.pageLinkType = links[style.linkCode]
      style.pageLinkValue = style.linkValue
    },
    normalizeDate(item) {
      const currentDate = new Date()

      //ios上 2020-10-01 10:10:10 这样会不生效，要替换成2020/10/01 10:10:10
      const seckillStartDate = new Date(item.startTime.replace(/\-/g, '/')) 

      const oneHour = 60 * 60 * 1000
      const seconds = seckillStartDate.getTime() - currentDate.getTime()
      // 距离当前场次一小时前显示倒计时
      if(seconds > 0 && seconds <= oneHour) {
        this.$set(item, 'visibleCountDown', true)
        this.$set(item, 'seconds', seconds)
      }
      this.$set(item, 'started', [1,2].includes(item.type))
      this.$set(item, 'hours', item.title.indexOf(':') > -1 ? item.title.split(':')[0] : '')
      this.$set(item, 'month', this.normalizeMonthDay(item.startTime))
    },
    normalizeMonthDay(time) {
      const [year, month, day] = time.split(' ')[0].split('-')
      return `${month}月${day}`
    },
    normalizeGoods(item) {
      const list = item.seckillActivityGoodsList
      const len = list.length
      
      list.forEach(goods => {
        this.$set(goods, 'photoFrameUrl', goods.cornerMark && goods.cornerMark.photoFrameImageUrl)
        this.setButtonName(goods)
      })
      this.$set(item, '$row', this.goodsRows[len >= 3 ? 3 : len])
      this.$set(item, 'goodsList', list)
    },
    setButtonName(goods) {
      const key = [1,2].includes(goods.buttonStatus) ? 'qiangName' : 'remindName'
      this.$set(goods, 'qiangName', '')
      this.$set(goods, 'remindName', '')
      this.$set(goods, key, this.buttonNames[goods.buttonStatus])
    },
    addZero(n) {
      return n < 10 ? '0' + n : n
    },
    onCountDownFinish(e) {
      const { floor } = this
      const item = floor.list[index]
      item.visibleCountDown = false
      item.started = true
    },
    onSeckillTixing(index, idx) {
      //buttonStatus 1=去看看(表示秒杀商品卖完了)，2=去抢购
      //3=提醒我(秒杀未开始，并且未添加提醒)，4=取消提醒(秒杀未开始且已添加提醒)
      const { floor } = this
      const goods = floor.list[index].goodsList[idx]
      if(goods.buttonStatus === 4) {
        return wx.showToast({
          title: '在开抢前五分钟会提醒你哦！',
          icon: 'none'
        })
      }
      if(goods.buttonStatus !== 3) return
      http({
        url: "order/user/seckill/follow/" + goods.seckillId,
        method: 'PUT'
      }).then(data => {
        goods.buttonStatus = 4
        this.setButtonName(goods)
        this.$toast('设置提醒成功')
      })
    },
    onNavigateTo() {
      const { style } = this.floor
      navigateTo(this, style)
    },
    /**
     * 下拉刷新后，如果秒杀商品数量改变
     * 则要更新一下<scroll-bar>组件
     * 的滚动条
     */
    updateScrollBar() {
      const scrollBars = this.$refs.scrollBar
      scrollBars && scrollBars.forEach(comp => {
        comp.updateThumbWidth()
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import url('./style-two.less');
</style>
